import React from 'react';
import GameScoreBoard from '../GameScoreBoard.js';
import {_GPY,__GPYGetRSS,__GPYPost} from '../../../env.js'

import GpyToggleButton from '../lib/GpyToggleButton.js';

import moment from 'moment';
import 'moment/locale/de';
import DatePicker from 'react-datepicker';
import WaitCube from '../../../WaitCube';

import ScoreboardDefaultHead from '../lib/ScoreboardDefaultHead.js';
import ScoreboardDisplayPanel from '../lib/ScoreboardDisplayPanel.js';
import ScoreboardFreeTextPanel from '../lib/ScoreboardFreeTextPanel.js';
import ScoreboardAdvertisementTournament from '../lib/ScoreboardAdvertisementTournament.js';

import $ from "jquery";

class SBHockey extends GameScoreBoard {

	constructor(props) {
		super(props);
		var s = super.getGPYState("LiveTV");
		s.NAME = "LiveTV";
		this.state = s;
		s.currentSet = 0;
		s.defaultDataStore = {homeScore:0,guestScore:0};
		s.currentCorona={date:new Date(),data:[],confirmed:0,recovered:0,deaths:0}
		s.mainClockDependenciesClocks=[
		   // {clock : this.state.NAME+'_countdown', button : this.state.NAME+'_button_start_stop_countdown'},
	  ];
		s.mainContentPanel=[{type:"news", title: "NEWS", timestamp:0, data:{title: _GPY.i18n.get('gametype_'+s.NAME+'_default_news_guppyi_title',"powered by guppyi - sports scoreboard"),description:_GPY.i18n.get('gametype_'+s.NAME+'_default_news_guppyi_desc',"www.guppyi.com"),published:"",publishedDate:new Date()}}];
		s.mainContentPanelOffset=0;
		s.homeCountry = "Germany";
		s.countryList = ["Germany"];
		s.lowerThird = _GPY.i18n.get('gametype_'+s.NAME+'_default_lower_third_text',"Max Mustermann");
		s.headLine = _GPY.i18n.get('gametype_'+s.NAME+'_default_channel_title',"Channel No.24 - Live aus Berlin");
		s.lowerThirdSub = _GPY.i18n.get('gametype_'+s.NAME+'_default_lower_third_sub_text',"#stayhome");
		s.RSSURL="https://www.rki.de/SiteGlobals/Functions/RSSFeed/RSSGenerator_nCoV.xml";
		s.displayNewsAppend = false;
		s.autoReloadMainContentRSS = false;

		s.news_content = "";
		s.news_headline = "";
		s.news_publishedDate = new Date();
		s.news_idx = -1;
		s.abspann = "";
		s.toStore = false;

	}


  /** the default delegate methods - works with standard state names **/
	componentDidMount() {
		super.componentDidMount();
		super.loadUserConfig().then((res)=>{
			super.getGamesStates();
			super.getGames();
			this.getCoronaStats();
			this.statsReloader = setInterval(() => this.getCoronaStats(), (60*60*1000));
			this.autoStore = setInterval(() => this.store(), (10*1000));
			this.load();
		});
	}

	setStateAndStore(obj,cb) {
		console.log("setStateAndStore:",obj);
		obj.toStore = true;
		this.setState(obj,cb);
	}

	load() {
		super.loadUserConfig("LiveTV_ENV_").then((res)=>{
			var obj = {};

			Object.keys(this.state.dataHooks).forEach((item, i) => {
					this.state.dataHooks[item].loadUserData(res);
			});

			if(res.mainContentPanel!==undefined) {
			 obj.mainContentPanelOffset=0;
			 obj.mainContentPanel=res.mainContentPanel;
			}
			if(res.lowerThird!==undefined) {
			 obj.lowerThird=res.lowerThird;
			}
			if(res.headLine!==undefined) {
			 obj.headLine = res.headLine;
			}
			if(res.lowerThirdSub!==undefined) {
			 obj.lowerThirdSub = res.lowerThirdSub;
			}
			if(res.RSSURL!==undefined) {
			 obj.RSSURL=res.RSSURL;
			}
			if(res.abspann!==undefined) {
			 obj.abspann=res.abspann;
			}
			this.setState(obj);
		});
	}

	store() {
		if(this.state.toStore) {
			this.setState({toStore:false},()=>{
						var data = {};
						Object.keys(this.state.dataHooks).forEach((item, i) => {
								this.state.dataHooks[item].storeUserData(data);
						});
						data.mainContentPanel = this.state.mainContentPanel;
						data.lowerThird = this.state.lowerThird;
						data.lowerThirdSub = this.state.lowerThirdSub;
						data.headLine = this.state.headLine;
						data.RSSURL = this.state.RSSURL;
						data.abspann = this.state.abspann;
						super.storeUserConfig("LiveTV_ENV_",data,(res)=>{
						});
			})
		}
	}

	componentWillUnmount() {
		 super.componentWillUnmount();
		 clearInterval(this.statsReloader);
		 clearInterval(this.autoStore);
	}

	getMainClock() {
 		return super.getMainClock();
	}
	togglePlay(method) {
		return super.togglePlay(method);
	}
	adjustTimers(millis,callback) {
		return super.adjustTimers(millis,callback) ;
	}
	arrayRemove(arr,idx) {
		arr.splice(idx,1);
		return arr;
	}

	changeHomeCountry(newHome) {
		console.log(newHome);
		if(newHome === this.state.homeCountry) {
			return;
		}
		this.setState({homeCountry:newHome},()=>{
			this.getCoronaStats();
		})
	}

  /** Init yout default Datastore **/
	initDataStore(id) {
		var ds = this.state.dataStore;
		this.setState({dataStore:ds});
	}

	genFromRSS(){
		__GPYGetRSS(this.state.RSSURL,(res)=>{
				var content = this.state.mainContentPanel;
			  var items = res.items
				items.map((i)=>{

						var d = "";
										try {
											var id =  new Date(_GPY.removeTags(i.published.trim()));
											d = id.toLocaleString(); // ("0"+id.getDay()).slice(-2)+"."+("0"+id.getMonth()).slice(-2)+" "+("0"+id.getHours()).slice(-2) + ":" +("0"+id.getMinutes()).slice(-2) + " Uhr : ";
											i.published = d;
											i.publishedDate = id;
										} catch (e) {
											console.log(e);
										}
										i.title = _GPY.decodeHtml(i.title);
										i.description = _GPY.removeTags(i.description.trim());

										var exist = false;
										for (var f in content) {
											if(content[f].data.title === i.title && content[f].data.published === i.published && content[f].data.description === i.description) {
												exist = true;
												break;
											}
										}
										if(!exist) {
											content.push( {type:"news", title: "NEWS", timestamp:0, data:i} );
										}
					});

					content.sort((a, b) => {
						if(a.data.publishedDate !== undefined && a.data.publishedDate!== undefined && a.data.publishedDate.getTime !== undefined && a.data.publishedDate.getTime !== undefined) {
								return b.data.publishedDate.getTime() - a.data.publishedDate.getTime();
						} else return 0;
					});
/*
					content.map((e)=>{
						console.log(e.data.publishedDate);
					})
*/
					this.setStateAndStore({mainContentPanel:content});
		});
	}

	onNewHomeCountry(){
		if(this.state.coronaData===undefined) return;
		var co = this.state.currentCorona;
		co.data = this.state.coronaData[this.state.homeCountry];


		co.confirmedSum = 0;
		co.recoveredSum = 0;
		co.deathsSum = 0;
		try {
			Object.keys(this.state.coronaData).forEach((country, i) => {
					var cdata = this.state.coronaData[country];
					var o = cdata[ cdata.length-1];
					co.confirmedSum += o.confirmed;
					co.recoveredSum += o.recovered;
					co.deathsSum += o.deaths;
			});
		} catch (e) {
			co.confirmedSum = 0;
			co.recoveredSum = 0;
			co.deathsSum = 0;
		}

		var last = co.data[co.data.length-1];
		co.confirmed = last.confirmed;
		co.recovered = last.recovered;
		co.deaths = last.deaths;
		co.date = last.date;

		this.setState({currentCorona:co},()=>{
			if(this.state.components[this.state.NAME+"_button_infekt_stats"] !== undefined) {
				this.state.components[this.state.NAME+"_button_infekt_stats"].updateData();
			}
		});
	}

	getCoronaStats(){
		fetch("https://pomber.github.io/covid19/timeseries.json")
	  .then(response => response.json())
	  .then(data => {
			var countryList = [];
			Object.keys(data).forEach((item,i) => {
				countryList.push(item);
			});
			this.setState({countryList:countryList,coronaData:data},()=>{
					this.onNewHomeCountry();
			});
	  })
	}

render () {
		const sponsorLogo = this.state.currentGame.sponsorLogo!==undefined&&this.state.currentGame.sponsorLogo!==''?this.state.currentGame.sponsorLogo:"empty.png";
		if(!this.state.defaultValuesLoaded) {
			return (<>Test<WaitCube/></>);
		}
	  return (
			<>
					<ScoreboardDefaultHead scoreboard={this} beta={false}/>
					<div className="row p-3">
					 <div className="col" style={{maxWidth:this.state.displayWidth+"px"}}>
								<ScoreboardDisplayPanel scoreboard={this} />
								<div className="row">
										<div className="col-3">{_GPY.i18n.get('gametype_'+this.state.NAME+'_default_stats_location',"location")}</div>
										<div className="col-3">{_GPY.i18n.get('gametype_'+this.state.NAME+'_default_stats_confirmed',"confirmed")}</div>
										<div className="col-3">{_GPY.i18n.get('gametype_'+this.state.NAME+'_default_stats_recovered',"recovered")}</div>
										<div className="col-3">{_GPY.i18n.get('gametype_'+this.state.NAME+'_default_stats_deaths',"deaths")}</div>
								 </div>
								 <div className="row">
								 		<div className="col-3">{this.state.homeCountry}</div>
										<div className="col-3">{new Number(this.state.currentCorona.confirmed).toLocaleString()}</div>
										<div className="col-3">{new Number(this.state.currentCorona.recovered).toLocaleString()}</div>
										<div className="col-34">{new Number(this.state.currentCorona.deaths).toLocaleString()}</div>
								 </div>
								 <div className="row">
								 		<div className="col-3"><small>World</small></div>
										<div className="col-3"><small>{new Number(this.state.currentCorona.confirmedSum).toLocaleString()}</small></div>
										<div className="col-3"><small>{new Number(this.state.currentCorona.recoveredSum).toLocaleString()}</small></div>
										<div className="col-34"><small>{new Number(this.state.currentCorona.deathsSum).toLocaleString()}</small></div>
								 </div>

								<div className="row"><div className="col-12 p-1">
									<div className="form-group">
								    <select className="form-control" onChange={(e)=>{this.changeHomeCountry(e.target.value)}} value={this.state.homeCountry}>
								      {this.state.countryList.map((c)=>
												<option key={c}>{c}</option>
											)}
								    </select>
								  </div>
								</div>
								</div>

								<div className="row"><div className="col-6 p-1">
								<GpyToggleButton
										title={_GPY.i18n.get('gametype_'+this.state.NAME+'_button_covid-19_title',"COVID-19 today")}
										onInit={() => {return {}}}
										onDeactivate={() => {return {visible: false,text:""}}}
										onActivate={() => {return {visible: true,
											country:this.state.homeCountry,

											confirmed:_GPY.i18n.get('gametype_'+this.state.NAME+'_default_stats_confirmed',"confirmed") + " " + new Number(this.state.currentCorona.confirmed).toLocaleString(),
											recovered:_GPY.i18n.get('gametype_'+this.state.NAME+'_default_stats_recovered',"recovered") + " "+ new Number(this.state.currentCorona.recovered).toLocaleString(),
											deaths:_GPY.i18n.get('gametype_'+this.state.NAME+'_default_stats_deaths',"deaths") + " "+ new Number(this.state.currentCorona.deaths).toLocaleString(),

											confirmedSum:  new Number(this.state.currentCorona.confirmedSum).toLocaleString(),
											recoveredSum:  new Number(this.state.currentCorona.recoveredSum).toLocaleString(),
											deathsSum:  new Number(this.state.currentCorona.deathsSum).toLocaleString(),

										}}}
										scoreboard={this}
										getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
										stateName={this.state.NAME+"_button_infekt_stats"}/>
								</div>
								<div className="col-6 p-1">
								<GpyToggleButton
										title="Guppyi (Thanks)"
										onInit={() => {return {}}}
										onDeactivate={() => {return {visible: false,text:""}}}
										onActivate={() => {return {visible: true}}}
										scoreboard={this}
										getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
										stateName={this.state.NAME+"_button_guppyi"}/>
								</div>
								</div>

								<div className="row"><div className="col-12 p-1">
								<GpyToggleButton
										title={_GPY.i18n.get('gametype_'+this.state.NAME+'_button_covid-19_rotate_title',"COVID-19 (rotate all countrys)")}
										onInit={() => {return {}}}
										prepareRestart={()=> {
											var idx = this.state.countryList.indexOf(this.state.homeCountry);
											if( (1+idx) < this.state.countryList.length ) {
												this.setState({homeCountry:this.state.countryList[1+idx]},()=>this.onNewHomeCountry());
											} else {
												this.setState({homeCountry:this.state.countryList[0]},()=>this.onNewHomeCountry());
											}
										}}
										onDeactivate={() => {return {visible: false,text:""}}}
										onActivate={() => {return {visible: true,

											country:this.state.homeCountry,
											confirmed:_GPY.i18n.get('gametype_'+this.state.NAME+'_default_stats_confirmed',"confirmed") + " " + new Number(this.state.currentCorona.confirmed).toLocaleString(),
											recovered:_GPY.i18n.get('gametype_'+this.state.NAME+'_default_stats_recovered',"recovered") + " "+ new Number(this.state.currentCorona.recovered).toLocaleString(),
											deaths:_GPY.i18n.get('gametype_'+this.state.NAME+'_default_stats_deaths',"deaths") + " "+ new Number(this.state.currentCorona.deaths).toLocaleString(),

											confirmedSum: new Number(this.state.currentCorona.confirmedSum).toLocaleString(),
											recoveredSum: new Number(this.state.currentCorona.recoveredSum).toLocaleString(),
											deathsSum: new Number(this.state.currentCorona.deathsSum).toLocaleString(),

										}}}
										scoreboard={this}
										getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
										autoexpiryRestart="2000"
										autoexpirytime="16"
										stateName={this.state.NAME+"_button_infekt_stats_rotate"}/>


								</div>
								<div className="col-6 p-1">

								</div>
								</div>

								<div className="row">
								<div className="col-8 p-1">
								<GpyToggleButton
										title={_GPY.i18n.get('gametype_'+this.state.NAME+'_button_newsroom_title',"Newsroom")}
										onInit={() => {return {}}}
										onDeactivate={() => {
											if(this.state.components.OBS!==undefined) {
												this.state.components.OBS.switchToScene("Fullscreen");
											}
											return {visible: false}
										}}
										onActivate={() => {

											if(this.state.components.OBS!==undefined) {
												this.state.components.OBS.switchToScene("Newsroom");
											}
											return {visible: true}}}
										scoreboard={this}
										getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
										stateName={this.state.NAME+"_button_newsroom"}/>
								</div>
								<div className="col-4 p-1">
								<GpyToggleButton
										title={_GPY.i18n.get('gametype_'+this.state.NAME+'_button_clock_title',"Clock")}
										onInit={() => {return {}}}
										onDeactivate={() => {return {visible: false,text:""}}}
										onActivate={() => {return {visible: true,
											gmt: -(new Date().getTimezoneOffset()/60),
										}
										}}
										scoreboard={this}
										getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
										stateName={this.state.NAME+"_button_analog_time"}/>
								</div>
								</div>


								<div className="row">
								<div className="col-12  p-1">
									<div className="form-group">
								 		<label><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_credits')}</strong></label>
									 	<textarea className="form-control" ignorekeys="true"  onChange={(e)=>{this.setStateAndStore({abspann:e.target.value})}} value={this.state.abspann}  rows={13}></textarea>
										</div>
								</div>
								<div className="col-12  p-1"><GpyToggleButton
										title={_GPY.i18n.get('gametype_'+this.state.NAME+'_button_credits_title',"start/restart credits")}
										onInit={() => {return {}}}
										onDeactivate={() => {return {visible: false,text:""}}}
										onActivate={() => {return {visible: true,
											text : this.state.abspann,
										}}}
										scoreboard={this}
										getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}

										stateName={ ()=>{
											var nr = this.state.components[this.state.NAME+"_button_newsroom"];
											if(nr!==undefined&&nr.isActive()) {
												return this.state.NAME + "_button_credits_newsroom";
											} else {
												return this.state.NAME + "_button_credits";
											}
										}}
										/>
								</div>
								</div>
					 </div>

					 <div className="col-sm col-md col-lg col-xl">
					 			<div className="row">
										<div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">

											<div className="row">
											<div className="col-8 p-1"><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_headline_live',"Live Overlays")}</strong></div>
											<div className="col-4 p-1 text-right">
											<form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
											 <input type="hidden" name="cmd" value="_s-xclick" />
											 <input type="hidden" name="hosted_button_id" value="V6WBK9QGHLY52" />
											 <input type="image" src="https://www.paypalobjects.com/de_DE/DE/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Spenden mit dem PayPal-Button" />
											 <img alt="" border="0" src="https://www.paypal.com/de_DE/i/scr/pixel.gif" width="1" height="1" />
											</form>
											</div>


												<div className="col-12 p-1">
													<div className="form-group"><input type="Text" onChange={(e)=>{this.setStateAndStore({headLine:e.target.value})}} className="form-control"  value={this.state.headLine} placeholder="rss URL"/></div>
												</div>

												<div className="col-12 p-1">
													<div className="form-group">
													<input type="Text" onChange={(e)=>{this.setStateAndStore({lowerThird:e.target.value})}} className="form-control" value={this.state.lowerThird} placeholder="Name"/>
													<input type="Text" onChange={(e)=>{this.setStateAndStore({lowerThirdSub:e.target.value})}} className="form-control" value={this.state.lowerThirdSub} placeholder="Sub name"/>
												 </div>
												</div>


												<div className="col-4 p-1">
												<GpyToggleButton
														title={_GPY.i18n.get('gametype_'+this.state.NAME+'_button_lower_third_title',"LowerThird Info")}
														onInit={() => {return {}}}
														onDeactivate={() => {
															return {visible: false}}}
														onActivate={() => {
															var res = {visible: true,
																text: this.state.lowerThird,
																subText: this.state.lowerThirdSub,
															}
															return res;
														}}
														scoreboard={this}
														autoexpirytime="10"
														getTime={ () => {return 0;} }
														getGameId={() => {return -1} }

														stateName={ ()=>{
															var nr = this.state.components[this.state.NAME+"_button_newsroom"];
															if(nr!==undefined&&nr.isActive()) {
																return this.state.NAME + "_lowerThird_newsroom";
															} else {
																return this.state.NAME + "_lowerThird";
															}
														}}
														/>
												</div>
												<div className="col-4 p-1">
												<GpyToggleButton
														title={_GPY.i18n.get('gametype_'+this.state.NAME+'_button_top_corner_title',"Top Corner Info")}
														onInit={() => {return {}}}
														onDeactivate={() => {
															return {visible: false}}}
														onActivate={() => {
															var res = {visible: true,
																text: this.state.lowerThird,
																subText: this.state.lowerThirdSub,
															}
															return res;
														}}
														scoreboard={this}
														getTime={ () => {return 0;} }
														getGameId={() => {return -1} }

														stateName={ ()=>{
															var nr = this.state.components[this.state.NAME+"_button_newsroom"];
															if(nr!==undefined&&nr.isActive()) {
																return this.state.NAME + "_topCorner_newsroom";
															} else {
																return this.state.NAME + "_topCorner";
															}
														}}
														/>
												</div>

												<div className="col-4 p-1">
												<GpyToggleButton
														title="headLine"
														onInit={() => {return {}}}
														onDeactivate={() => {
															return {visible: false}}}
														onActivate={() => {
															var res = {visible: true,
																text: this.state.headLine,
															}
															return res;
														}}
														scoreboard={this}
														getTime={ () => {return 0;} }
														getGameId={() => {return -1} }
														stateName={ this.state.NAME + "_headline"}
														/>
												</div>
											</div>
											<div className="row"><div className="col-12"><ScoreboardFreeTextPanel showFreeText={false} generators={{rss:true}} textRows={11} scoreboard={this} /></div></div>
											<ScoreboardAdvertisementTournament scoreboard={this}/>

										</div>

										<div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">

										<div className="row">
											<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_headline_maincontent',"RSS Content (change RSS feed url or press plus)")}</strong></div>
											<div className="col-12 p-1">
												<div className="form-group"><input type="Text" onChange={(e)=>{this.setStateAndStore({RSSURL:e.target.value})}} className="form-control" aria-describedby="_RSSURL" value={this.state.RSSURL} placeholder="rss URL"/></div>
											</div>

											<div className="col-6 p-1">
											<GpyToggleButton
													title={_GPY.i18n.get('gametype_'+this.state.NAME+'_button_main_content_title',"Show Main Content")}
													onInit={() => {return {}}}
													prepareRestart={()=> {
														var offset = this.state.mainContentPanelOffset;
														offset += 1;
														this.setState({mainContentPanelOffset:offset});
													}}
													onDeactivate={() => {
														return {visible: false}}}
													onActivate={() => {
														var offset = this.state.mainContentPanelOffset;
														if(offset >= this.state.mainContentPanel.length) {
														 offset = 0;
														 this.setState({mainContentPanelOffset:offset});
														}

														var res = {visible: true,
															content: this.state.mainContentPanel[offset],
														}
														return res;
													}}
													scoreboard={this}
													autoexpiryRestart="1500"
													autoexpirytime="16"
													getTime={ () => {return 0;} }
													getGameId={() => {return -1} }
													stateName={ this.state.NAME + "_content_news" }/>
											</div>

											<div className="col-6 p-1">

											<div className="btn-group w-100" role="group" aria-label="Basic example">
												<button type="button"  className="btn btn-secondary btn-sm" onClick={()=>{
													 this.genFromRSS();
												}}>{_GPY.i18n.get('gametype_'+this.state.NAME+'_button_append_rss_title',"append RSS news")} &darr;</button>
												<button type="button"  className={"btn btn-sm " + (this.state.autoReloadMainContentRSS?"btn-danger":"btn-dark")} onClick={()=>{
													 if(this.state.autoReloadMainContentRSS) {
														 clearInterval(this.autoUpdateMainContentRSSInterval);
														 this.setState({autoReloadMainContentRSS:false});
													 } else {
														 this.autoUpdateMainContentRSSInterval = setInterval(()=>{
															  this.genFromRSS();
														 },(30*60*1000));
														 this.setState({autoReloadMainContentRSS:true});
													 }
												}}><div style={{ animation: (!this.state.autoReloadMainContentRSS?" emptyanim":" rotateAnim 10s infinite linear")}}><span className="glyphicon glyphicon-refresh" aria-hidden="true"></span></div></button>
												</div>
											</div>
										</div>


										<div className="row">
												<div className="col-6 p-1">
												 {!this.state.displayNewsAppend?
														 <button type="button" onClick={()=>{
															 	 this.setState({displayNewsAppend:true,news_idx:-1,news_publishedDate:new Date(),news_headline:"",news_content:""});
														 }} className={"btn btn-sm btn-outline-secondary"}><span className={"glyphicon glyphicon-plus"} aria-hidden="true"></span></button>
												 :""}
											 </div>

											 <div className="col-6 p-1 text-right">
											 {this.state.displayNewsAppend?
												 <button type="button" onClick={()=>{
														 this.setState({displayNewsAppend:false});
												 }} className={"btn btn-link self-align-right"}><span className={"glyphicon glyphicon-remove text-danger"} aria-hidden="true"></span></button>
												 :""}
											 </div>
 										</div>
										<div className="row">
{this.state.displayNewsAppend?
											<div className="col-12 p-1">
											<div className="form-group">

															<DatePicker className="form-control" selected={this.state.news_publishedDate!==undefined?this.state.news_publishedDate:new Date()} onChange={(e) => {
																console.log("setDateTo",e);
																this.setState({ news_publishedDate: e});
															}}
													  		showTimeSelect timeFormat="HH:mm"
																	timeIntervals={5}
																	dateFormat="dd/MM/yyyy HH:mm"/>

												<label htmlFor="exampleFormControlTextarea1"><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_append_news_headline_title')}</strong></label>
												<textarea className="form-control" ignorekeys="true"  onChange={(e)=>{this.setState({news_headline:e.target.value})}} value={this.state.news_headline}rows={2}></textarea>

												<label htmlFor="exampleFormControlTextarea1"><strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_append_news_content_title')}</strong></label>
												<textarea className="form-control" ignorekeys="true"  onChange={(e)=>{this.setState({news_content:e.target.value})}} value={this.state.news_content} rows={8}></textarea>

												<button className="btn btn-primary btn-sm  btn-block pt-1" onClick={()=>{

													 var n = {type:"news", title: "NEWS", timestamp:0, data:{}};
													 n.data.title = this.state.news_headline;
													 n.data.description = this.state.news_content;
													 n.data.publishedDate = this.state.news_publishedDate;

	 											 	 var mc = this.state.mainContentPanel;

													 if(this.state.news_idx>=0 && this.state.news_idx<mc.length){
														mc[this.state.news_idx] = n;
													 } else {
														 mc.push(n);
													 }

													 mc.sort((a, b) => {
 														if(a.data.publishedDate !== undefined && b.data.publishedDate!== undefined && a.data.publishedDate.getTime !== undefined && b.data.publishedDate.getTime !== undefined) {
 																return b.data.publishedDate.getTime() - a.data.publishedDate.getTime();
 														} else return 0;
 													});

													 this.setStateAndStore({mainContentPanel:mc,displayNewsAppend:false});

												}}>{this.state.news_idx>=0?"change news":"append news"}</button>
											</div>
											</div>
:""}
										</div>

										<div className="row" style={{height: "750px",overflow:"scroll"}}>
											 <div className="col-12 p-1">
												 <div className="list-group">
														{this.state.mainContentPanel.map((i,idx)	 => {
															return (
																<div className={"list-group-item pt-0 pb-0"+(this.state.mainContentPanelOffset===idx?" list-group-item-success":"")}>
																<div className="row p-1">
																	 <div className="col-7 p-0"><small>{i.data.publishedDate.toLocaleString()}</small><br/><strong>{i.data.title}</strong>
																	 </div>
																	 <div className="col-5 p-0 text-right">

																		 <div className="modal linkfade" id={"mainModal_"+idx}  role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
																			 <div className="modal-dialog" role="document">
																				 <div className="modal-content">
																				 	 <div className="modal-header">
																						 <h5 className="modal-title" id="exampleModalLongTitle">{i.data.title}</h5>
																						 <button type="button" className="close" data-dismiss="modal" aria-label="Close">
																							 <span aria-hidden="true">&times;</span>
																						 </button>
																						</div>
																					<div className="modal-header"><small>{i.data.publishedDate+""}</small></div>
																					 <div className="modal-body">{i.data.description}</div>
																					 <div className="modal-footer">
																						 <button type="button"  onClick={()=>{
																							  this.setStateAndStore({mainContentPanel: this.arrayRemove(this.state.mainContentPanel,idx)})
																								$('#mainModal_'+idx).modal('hide');
																						 }} className="btn btn-danger">Remove</button>
																						 <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
																					 </div>
																				 </div>
																			 </div>
																		 </div>

																		 <div className="btn-group" role="group" aria-label="Basic example">
																			 <button className="btn btn-sm btn-light" onClick={()=>this.setState({mainContentPanelOffset:idx})} ><span className="glyphicon glyphicon-play-circle" aria-hidden="true"></span></button>
																			 <button className="btn btn-sm btn-light" data-toggle="modal" data-target={"#mainModal_"+idx}><span className="glyphicon glyphicon-info-sign" aria-hidden="true"></span></button>
																			 <button className="btn btn-sm btn-light" onClick={()=>{
																				 console.log("äüüüü",i.data.publishedDate);
																				  this.setState({news_idx:idx,news_headline:i.data.title,news_content:i.data.description,news_publishedDate:i.data.publishedDate,displayNewsAppend:true});
																			 }} ><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></button>
																			 <button className="btn btn-sm btn-light" onClick={()=>{
																				  this.setStateAndStore({mainContentPanel: this.arrayRemove(this.state.mainContentPanel,idx)})
																			 }} ><span className="glyphicon glyphicon-remove" aria-hidden="true"></span></button>
																		 </div>
																	 </div>
																 </div>
																</div>
														 );
													 })}
												 </div>
											 </div>
										</div>

										</div>

								</div>
					   </div>
					</div>

		</>
   )
  }
}
export default SBHockey;
